export default __webpack_public_path__ + "static/media/new4.4818af3a.jpg";